import(/* webpackMode: "eager" */ "/tmp/build_21151e7c/node_modules/react-toastify/dist/react-toastify.esm.mjs");
import(/* webpackMode: "eager" */ "/tmp/build_21151e7c/src/app/investors/[userGroupId]/view.tsx");
import(/* webpackMode: "eager" */ "/tmp/build_21151e7c/src/images/userprofile.png")